const auth = {
  'sk': 'System kolejkowy',
  'login-via-sso': 'Zaloguj przez SSO',
  'login-locally': 'Zaloguj lokalnie',
  login: 'Zaloguj',
  username: 'Nazwa użytkownika',
  password: 'Hasło',
  'username-required': 'Nazwa użytkownika jest wymagana',
  'password-required': 'Hasło jest wymagane',
  'login-as-worker': 'Zaloguj jako pracownik',
  logout: 'Wyloguj',
  'sso-info-1': 'SSO - system logowania przeznaczony dla studentów',
  'sso-info-2': 'oraz pracowników Politechniki Wrocławskiej',
  error: 'Błędna nazwa użytkownika lub hasło!',
  'back-to-home': 'Powrót do strony głównej'
};

export default auth;
